export default `
<section>
  <h2>OIKEUDELLINEN HUOMAUTUS
  </h2>
  <p>InnoCAPE (Industry 4: transforming innovation ecosystem through better capacity of public enablers) on Interreg BSR
    -ohjelman tukema projekti, joka ylläpitää verkkotunnuksia *
    <a target="_blank" href="https://innocape.eu" rel="noopener noreferrer">.innocape.eu
    </a>.
  </p>
  <section>
    <h3>Verkkosivustojen rekisterinpitäjä ja henkilötietojesi käsittely
    </h3>
    <p>Sunrise Valley Science and Technology Park
    </p>
    <p>Y-tunnus Liettuan yritysrekisterissä: 3126224832
    </p>
    <p>Osoite: Saulėtekio al. 15, LT-10224 Vilna
    </p>
    <p>Yhteydenotto verkkolomakkeella:
      <a target="_blank" href="https://ssmtp.lt/en/contacts/" rel="noopener noreferrer">https://ssmtp.lt/en/contacts/
      </a>
    </p>
    <p>Sivustoa www.innocape.eu säätelee Liettuan laki.
    </p>
  </section>
  <section>
    <h3>Toimituskunta
    </h3>
    <p>Sivustojen sisällön luonut InnoCAPE-projektikumppaneiden viestintäryhmä:
      <a target="_blank" href="https://innocape.eu/#partners" rel="noopener noreferrer">https://innocape.eu/#partners
      </a>
    </p>
  </section>
  <section>
    <h3>Tekijänoikeus
    </h3>
    <p>© InnoCAPE, 2020
    </p>
    <p>Kuvien, videoiden ja muun sisällön jäljentäminen on sallittua ei-kaupallisiin tarkoituksiin lähde mainiten, ellei
      toisin mainita. Jos teksti- ja multimediatietojen (ääni, kuvat, ohjelmistot jne.) jäljentämiseen tai käyttöön on
      hankittava etukäteen lupa, lupa mitätöi edellä mainitun yleisen luvan ja siinä on selvästi mainittava kaikki
      käytön rajoitukset.
    </p>
  </section>
  <section>
    <h3>Ulkoinen sisältö
    </h3>
    <p>Verkkosivustomme sisältää erilaisia ​​hyperlinkkejä ulkoisiin verkkosivustoihin sekä upotettuja sosiaalisen
      median syötteitä. InnoCAPE ei ole vastuussa ulkoisten verkkosivustojen ja sosiaalisen median tilien kontekstista,
      jota InnoCAPE viestintätiimi ei hallinnoi.
    </p>
  </section>
  <section>
    <h3>Projektin verkkosivustot
    </h3>
    <p>Sivustollamme on useita yksittäisiä projektiin liittyviä alisivustoja. Vastuu näiden verkkosivustojen sisällöstä
      on InnoCAPE-projektin -
      <a target="_blank" href="https://ssmtp.lt/en" rel="noopener noreferrer">Sunrise Valley Science &amp; Technology
        Park
      </a> - pääpartnerin alaisuudessa.
    </p>
  </section>
  <section>
    <h3>Ylläpito
    </h3>
    <p>
      <a target="_blank" href="https://www.innocape.eu" rel="noopener noreferrer">www.innocape.eu
      </a> -sivustoa ylläpitää “Telia Lietuva” AB, Vilna, Liettua (
      <a target="_blank" href="https://www.hostex.lt" rel="noopener noreferrer">www.hostex.lt
      </a>).
      <a target="_blank" href="https://dma.innocape.eu" rel="noopener noreferrer">dma.innocape.eu
      </a> (DMA) -sivustoa ylläpitää SIA “CUBE Systems” (
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">www.cubesystems.lv
      </a>), Riga Latvia (
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">www.cubesystems.lv
      </a>).
      <a target="_blank" href="https://cmap.innocape.eu" rel="noopener noreferrer">cmap.innocape.eu
      </a> -sivustoa ylläpitää SIA “Gstream” (
      <a target="_blank" href="https://www.easyhosting.lv" rel="noopener noreferrer">www.easyhosting.lv
      </a>), Riga, Latvia.
    </p>
  </section>
</section>
<section>
  <h2>TIETOSUOJAKÄYTÄNTÖ
  </h2>
  <p>Tämä tietosuojakäytäntö koskee vain verkkosivustoamme ja alisivustoja. Jos napsautat linkkiä muille
    verkkosivustoille, sinun tulee lukea heidän tietosuojakäytäntönsä.
  </p>
  <p>InnoCAPE on sitoutunut henkilötietojen suojaamiseen. Teemme parhaamme käsitelläksemme henkilötietojasi
    <a target="_blank" href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32016R0679"
      rel="noopener noreferrer">yleisen tietosuoja-asetuksen (GDPR)
    </a> mukaisesti. Tässä tietosuojakäytännössä selitetään, kuinka käytämme sinulta keräämiämme henkilötietoja, kun
    osallistut projektiimme, esimerkiksi käyttämällä verkkosivustoamme, osallistumalla tapahtumiin tai käyttämällä
    projektikumppanien luomia verkkotyökaluja.
  </p>
  <p>InnoCAPE kerää henkilötietoja digikypsyysmittarille (DMA) ja kompetenssikartalle (CMAP) omistetuilla
    online-työkaluillamme ja verkkosivustoillamme ja käsittelee niitä asianmukaisella huolella kaikkien sovellettavien
    vaatimusten ja henkilötietojen hallintaa ja suojaa sääntelevien Liettuan tasavallan lakien mukaisesti.
  </p>
  <section>
    <h3>i) Käsiteltävät henkilötiedot ja tietolähteet
    </h3>
    <p>InnoCAPE kerää seuraavan tyyppisiä tietoja käyttäjiltämme: (i) käyttäjätiedot; ja (ii) tekniset tiedot. Vaikka
      emme yleensä käytä teknisiä tietoja tunnistaaksemme sinua yksilönä, sinut voidaan joskus tunnistaa siitä.
      Tällaisissa tilanteissa teknisiä tietoja voidaan myös pitää henkilötietoina sovellettavan lain mukaan.
    </p>
    <p>InnoCAPE DMA:n tai CMAP:n kautta voimme kerätä ja käsitellä seuraavia käyttäjätietoja osallistujistamme ja
      vierailijoistamme: (i) etu- ja sukunimi; (ii) osoitetiedot, (iii) puhelinnumero, (iv) sähköpostiosoite, (v)
      sijaintisi, kun käytät palveluitamme, (vi) oppilaitos tai erityiset taidot työpaikalla, (vii) yritystiedot
      (kuvaus, verkkosivuston osoite, sosiaalisen median linkit jne.).
    </p>
    <p>InnoCAPE voi kerätä käyttäjätietoja osallistujiltamme ja vierailijoiltamme monin eri tavoin, mukaan lukien
      rekisteröityessään palveluihimme tai online-työkaluihimme, kuten DMA ja CMAP, tilatessaan uutiskirjeen,
      rekisteröitymällä johonkin tapahtumistamme tai täyttämällä lomakkeen.
    </p>
    <p>InnoCAPE ja / tai valtuutetut kolmannen osapuolen palveluntarjoajamme voivat kerätä teknisiä tietoja
      automaattisesti, kun vierailet palveluissamme tai sivustollamme tai olet vuorovaikutuksessa niiden kanssa.
      Tekniset tiedot voivat sisältää selaimen nimen, tietokoneen tai laitteen tyypin, verkkosivustolla vietetyn ajan,
      vuorovaikutuksen palvelujen kanssa, käyttäjän vierailujen ajan ja päivämäärän, surffaustavat, IP-osoitteen,
      käyttöjärjestelmän ja muita vastaavia teknisiä tietoja.
    </p>
    <p>äytämme erilaisia tekniikoita keräämään ja tallentamaan julkisia tietoja, kun käytät InnoCAPE DMA- ja
      CMAP-verkkosivustoja (mukaan lukien evästeet, Google-tunnisteet, Analytics jne.).
    </p>
    <p>Evästeiden avulla voimme laskea verkkosivustoillamme vierailevien ihmisten kokonaismäärän ja seurata
      verkkosivuston käyttöä. Käytämme myös evästeitä, jotka helpottavat verkkosivuston käyttöä sinulle, esimerkiksi
      muistamalla käyttäjänimet, salasanat ja (kieli)mieltymykset. Käytämme myös seuranta- ja analyysievästeitä sen
      selvittämiseen, kuinka hyvin käyttäjät ottavat palvelumme vastaan.
    </p>
    <p>Voit halutessasi asettaa selaimesi kieltäytymään evästeistä tai varoittaa sinua, kun evästeitä lähetetään. Jos
      teet niin, huomaa, että jotkin sivustomme ja palvelujemme osat eivät välttämättä toimi oikein. Lisätietoja
      evästeistä ja niiden poistamisesta on osoitteessa
      <a target="_blank" href="https://www.allaboutcookies.org" rel="noopener noreferrer">www.allaboutcookies.org
      </a>.
    </p>
    <p>ivustomme käyttää Google Analyticsia ja muita verkkoanalyysipalveluja (kuten Google Tag Manager) kerätäkseen
      raportteja kävijöiden käyttäytymisestä ja auttaakseen meitä parantamaan sivustoamme ja palveluitamme. Saat
      yleiskatsauksen Google Analyticsista käymällä osoitteessa
      <a target="_blank" href="https://www.google.com/analytics/"
        rel="noopener noreferrer">http://www.google.com/analytics/
      </a>. Yleiskatsaus Google Tag Managerista on osoitteessa
      <a target="_blank" href="https://support.google.com/tagmanager/answer/6102821?hl=en"
        rel="noopener noreferrer">https://support.google.com/tagmanager/answer/6102821?hl=en
      </a>
    </p>
  </section>
  <section>
    <h3>ii) Henkilötietojesi käsittelyn tarkoitukset ja lailliset perusteet
    </h3>
    <p>Henkilötietojesi käsittelylle InnoCAPE:ssa on useita syitä:
    </p>
    <p>Palveluiden tarjoamiseksi ja sopimuksen täyttämiseksi kanssasi InnoCAPE ensisijaisesti käsittelee
      henkilötietojasi voidakseen toimittaa palvelumme sinulle. Tähän sisältyy digitaalisen kypsyyden arviointityökalun
      käytöstä saatujen tietojen käsittely anonymisoidussa ja yhdistetyssä muodossa analysoimaan digitalisaation tilaa
      eri toimialoilla ja maantieteellisillä alueilla. Käytämme tietoja myös ottaaksemme sinuun yhteyttä, jos haluat,
      tarjotaksemme lisäapua digikypsyysarvioinnin jälkeen.
    </p>
    <p>InnoCAPE käsittelee henkilötietojasi osana asiakasviestintää ottaakseen sinuun yhteyttä palveluihimme liittyen ja
      ilmoittaakseen sinulle muutoksista palveluissamme. Tietojasi käytetään myös tutkimukseen ja analyyseihin
      palveluidemme ja verkkosivustomme parantamiseksi. Voimme myös käyttää verkkosivustollemme syötettyjä tietojasi
      tietyissä tapauksissa lähettämään tietoja sähköpostitse projektista, jos olet antanut meille siihen suostumuksen.
    </p>
  </section>
  <section>
    <h3>iii) Vastaanottajat
    </h3>
    <p>Jaamme henkilötietojasi vain InnoCAPE-konsortion organisaatiossa ja Interreg Baltic Sea Region -hallinnossa /
      yhteisessä sihteeristössä, jos ja siltä osin kuin se on kohtuudella tarpeen palveluidemme suorittamiseksi ja
      kehittämiseksi ja projektin toteuttamiseksi.
    </p>
    <section>
      <h4>Se on välttämätöntä tämän tietosuojaselosteen tarkoituksia varten
      </h4>
      <p>Kun kolmannet osapuolet tarvitsevat pääsyn henkilötietoihin tällaisten palvelujen suorittamiseksi, InnoCAPE on
        toteuttanut asianmukaiset sopimus- ja organisatoriset toimenpiteet varmistaakseen, että tietojasi käsitellään
        yksinomaan tässä tietosuojaselosteessa määriteltyihin tarkoituksiin ja kaikkien sovellettavien lakien ja
        asetusten mukaisesti. Lisäksi voimme toimittaa henkilötietosi tytäryhtiöillemme tai muille luotetuille
        yrityksille tai henkilöille käsittelemään niitä meille, ohjeidemme perusteella, tietosuojalausuntomme ja muiden
        sopivien luottamuksellisuus- ja turvatoimenpiteiden mukaisesti.
      </p>
    </section>
    <section>
      <h4>Oikeudellisista syistä
      </h4>
      <p>Voimme jakaa henkilötietojasi InnoCAPE-alueen ulkopuolisten kolmansien osapuolten kanssa, jos uskomme
        vilpittömässä mielessä, että pääsy henkilötietoihin ja niiden käyttö on kohtuullisen välttämätöntä (i)
        sovellettavan lain, asetusten ja / tai tuomioistuimen määräysten noudattamiseksi; (ii) petoksien, turvallisuus-
        tai teknisten ongelmien havaitsemiseksi, estämiseksi tai muutoin niihin puuttumiseksi; ja / tai (iii) suojella
        InnoCAPE:n, käyttäjien tai yleisön etuja, ominaisuuksia tai turvallisuutta lain mukaisesti. Milloin mahdollista,
        ilmoitamme sinulle tällaisesta käsittelystä.
      </p>
    </section>
  </section>
  <section>
    <h3>iv) Tietojen säilytysaika
    </h3>
    <p>InnoCAPE ei säilytä henkilötietojasi pidempään kuin on lain mukaan sallittua ja tarpeen niihin tarkoituksiin,
      joita varten tiedot on kerätty. Säilytysaika riippuu tietojen luonteesta ja käsittelyn tarkoituksista. Siksi
      teknisten tietojen enimmäisaika voi vaihdella käytön mukaan, niin kauan kuin pidämme sivustoamme verkossa.
      Tallennamme henkilötietojasi palvelujen tarjoamista varten enintään viiden vuoden ajan projektin päättymisen
      jälkeen, mikä DMA- ja CMAP-työkalun kannalta tarkoittaa lokakuuta 2021.
    </p>
  </section>
  <section>
    <h3>v) Oikeutesi
    </h3>
    <section>
      <h4>Oikeus käyttää sinua koskevia tietoja
      </h4>
      <p>InnoCAPE tarjoaa sinulle pääsyn käsittelemiimme henkilötietoihin. Tämä tarkoittaa sitä, että voit ottaa meihin
        yhteyttä pyytämällä meitä ilmoittamaan sinulle keräämistämme ja käsittelemistämme henkilötiedoistasi ja
        tarkoituksista, joihin tällaisia ​​tietoja käytetään.
      </p>
    </section>
    <section>
      <h4>Oikeus tietojen oikaisemiseen
      </h4>
      <p>Sinulla on oikeus korjata tai täydentää virheellisiä / epätarkkoja, puutteellisia, vanhentuneita tai
        tarpeettomia henkilötietoja, jotka olemme tallentaneet sinusta.
      </p>
    </section>
    <section>
      <h4>Oikeus kaikkien tietojen poistamiseen
      </h4>
      <p>Voit myös pyytää meitä poistamaan henkilötietosi järjestelmistämme. Suostumme tällaisiin pyyntöihin, ellei
        meillä ole perusteltua syytä olla poistamatta tietoja. Kun tiedot on poistettu, emme välttämättä välittömästi
        pysty poistamaan kaikkia jäljellä olevia kopioita aktiivisilta palvelimiltamme ja
        varmuuskopiointijärjestelmistämme.
      </p>
    </section>
    <section>
      <h4>Oikeus vastustaa tietojesi käyttöä
      </h4>
      <p>Voit vastustaa henkilötietojesi tiettyä käyttöä, jos näitä tietoja käsitellään muihin tarkoituksiin kuin on
        tarpeen palveluidemme suorittamiseksi tai lakisääteisen velvoitteen noudattamiseksi. Voit myös vastustaa
        henkilötietojesi jatkokäsittelyä etukäteen annetun suostumuksen jälkeen. Jos vastustat henkilötietojesi
        jatkokäsittelyä, se voi johtaa palvelulaadun heikentymiseen.
      </p>
    </section>
    <section>
      <h4>Oikeus henkilötietojesi käsittelyn rajoittamiseen
      </h4>
      <p>Voit pyytää meitä rajoittamaan henkilötietojesi tiettyä käsittelyä. Jos rajoitat henkilötietojesi tiettyä
        käsittelyä, se voi johtaa palvelulaadun heikentymiseen.
      </p>
    </section>
    <section>
      <h4>Oikeus tietojen siirrettävyyteen
      </h4>
      <p>Sinulla on oikeus saada henkilötietosi meiltä, jotta voit välittää tiedot toiselle rekisterinpitäjälle.
      </p>
    </section>
    <section>
      <h4>Kuinka käyttää oikeuksiasi?
      </h4>
      <p>Voit käyttää näitä oikeuksia lähettämällä meille kirjeen tai sähköpostin, joka sisältää nimesi, osoitteesi,
        puhelinnumerosi ja kopion voimassa olevasta henkilötodistuksesta alla mainittuun osoitteeseen. Jos pidät
        henkilötietojesi käsittelyä ristiriidassa sovellettavien tietosuojalakien kanssa, voit tehdä valituksen
        paikalliselle tietosuojavalvontaviranomaiselle.
      </p>
    </section>
  </section>
  <section>
    <h3>vi) Tietosuoja
    </h3>
    <p>Teemme kaikki kohtuulliset ja asianmukaiset turvatoimet suojellaksemme InnoCAPE:a hallussamme olevien
      henkilötietojen luvattomalta käytöltä tai luvattomalta muutokselta, paljastamiselta tai tuhoamiselta. Toimenpiteet
      sisältävät tarvittaessa salauksen, palomuurit, suojatut tilat ja käyttöoikeusjärjestelmät. Jos turvatoimista
      huolimatta tapahtuu tietoturvaloukkauksia, joilla on todennäköisesti kielteisiä vaikutuksia yksityisyydellesi,
      ilmoitamme sinulle rikkomuksesta mahdollisimman pian.
    </p>
  </section>
  <section>
    <h3>vii) Muutokset tietosuojakäytäntöön
    </h3>
    <p>Tietosuojakäytäntö julkaistaan englanniksi ja se voi muuttua ajoittain. Löydät nykyisen version
      verkkosivustoltamme
      <a target="_blank" href="https://innocape.eu/privacy-policy/"
        rel="noopener noreferrer">https://innocape.eu/privacy-policy/
      </a>. Pidätämme oikeuden muuttaa tätä tietosuojakäytäntöä milloin tahansa. Kaikki muutokset julkaistaan
      kotisivullamme, jotta olet tietoinen muutoksista. Tämä tietosuojakäytäntö päivitettiin viimeksi 1. joulukuuta
      2020.
    </p>
  </section>
</section>
<section>
  <h2>YHTEYSTIEDOT:
  </h2>
  <p>Sunrise Valley Science and Technology Park
  </p>
  <p>Sauletekio ave. 15, LT-10224 Vilnius [Lithuania]
  </p>
  <p>Puh. + 370 640 56547
  </p>
  <p>Sähköposti: info@innocape.eu.
  </p>
</section>
`
